import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { UserIdleService } from 'angular-user-idle';
import { AuthService } from '../../services/auth.service';
import { ModalService } from '../../services/modal.service';
import { ModalHeaderComponent } from '../modal-header/modal-header.component';
import Constants from '../../../../assets/consts';
import { formatISO } from 'date-fns';

@Component({
  selector: 'timeout-modal',
  imports: [
    ModalHeaderComponent,
    MatDialogModule,
    MatButtonModule,
  ],
  templateUrl: './timeout-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './timeout-modal.component.scss'
})
export class TimeoutModalComponent {
  #modalService = inject(ModalService);
  #authService = inject(AuthService);
  #userIdleService = inject(UserIdleService)

  countdown = this.#authService.countdown;

  extendTime() {
    this.#userIdleService.stopTimer();
    this.#modalService.closeTimeoutModal();
    const NOW = new Date();
    localStorage.setItem(
      Constants.BROWSER_LOST_FOCUS_TIMESTAMP,
      formatISO(NOW)
    );
  }

  close(): void {
    this.#authService.appTimedOut();
  }
}
